import { useEffect, useState } from "react";
import CuForm from "../../common_component/component/CuForm";
import CuModal from "../../common_component/component/CuModal";
import DateAge from "../../new_appointment/_helper/utils.js/DateAge";
import { gender } from "../../new_appointment/appoinment/components/BookSlot";
import CuInput from "./CuInput";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuDropdown from "../../common_component/component/CuDropdown";
import { useItemsFilter } from "../../_helper/actions/app/items";
import CustomButton from "../../common_component/component/CustomButton";
import { toast } from "react-toastify";
import { useCreateItem } from "../../_helper/actions/mutation/items";
import { useCurrentRole } from "../../_helper/constant/Permission";

const AddUserModal = ({ type, closeModal }) => {
  const [formData, setFormData] = useState({
    institution: {},
    phone: "",
    full_name: "",
    age: null,
    dob: "",
    gender: "",
  });
  const [clinic] = useAtom(clinicAtom);
  const [searchInput, setSearchInput] = useState("");
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const { role_id, isLoading: roleLoading } = useCurrentRole();

  const { data: institutionData } = useItemsFilter(
    ApiEndPoint.INSTITUTION_CUSTOMERS,
    `?action=getInstitutionCustomers&frontend=True&clinic_id=${clinic?.id}&search=${searchInput}`,
    clinic?.id ? true : false
  );

  useEffect(() => {
    if (institutionData) {
      const options = institutionData?.map((ins) => ({
        key: ins?.id,
        value: ins?.id,
        text: ins?.institution_name,
      }));
      setInstitutionOptions(options);
    }
  }, [institutionData]);

  const handleChange = (val, label) => {
    let updatedValue = val;
    if (label === "full_name") {
      updatedValue = val.replace(/[^a-zA-Z\s]/g, ""); // Remove special characters
    } else if (label === "phone") {
      updatedValue = val.replace(/[^0-9]/g, ""); // Only allow digits
    } else if (label === "dateAge") {
      if (!val.age || !val.dob) {
        return;
      }
      setFormData((prev) => ({ ...prev, ...val }));
      return;
    } else if (label === "institution") {
      const selectedCustomer = institutionData?.find((ins) => ins?.id === val);
      setFormData((prev) => ({ ...prev, [label]: selectedCustomer }));
      return;
    }

    setFormData((prev) => ({ ...prev, [label]: updatedValue }));
  };

  const createmutation = useCreateItem(ApiEndPoint.USERS);

  // //("full name -----", formData.full_name.trim().split(" ").length);

  const handleSubmit = (e) => {
    e.preventDefault();

    const { phone, full_name, age, dob, gender } = formData;

    // Validation: Check if any required field is empty
    if (!phone) {
      toast.error("Phone number is required");
      return;
    }

    if (!full_name || full_name.trim().split(" ").length <= 1) {
      toast.error("Full name is required and should have more than one word");
      return;
    }
    if (full_name && full_name.length > 50) {
      toast.error("Name is too long");
      return;
    }
    if (!age) {
      toast.error("Age is required");
      return;
    }
    if (!dob) {
      toast.error("Date of Birth is required");
      return;
    }

    if (!gender) {
      toast.error("Gender is required");
      return;
    }

    const fullName = full_name.trim().split(" ");
    const first_name = fullName[0];
    const last_name = fullName[fullName.length - 1];

    const payload = {
      action: "postUser",
      backend: "True",
      clinic_id: clinic?.id,
      first_name,
      last_name,
      email: `${phone}@${
        formData?.institution?.id
          ? `institute${formData?.institution?.id}`
          : "gmail"
      }.com`,
      is_doctor: false,
      is_patient: true,
      mobile: phone,
      register_by_walkin: true,
      linked_clinics: [clinic?.id],
      linked_doctors: [role_id],
      is_active: true,
      patient_details: {
        age: Number(age),
        dob,
        full_name,
        gender,
        is_parent: true,
        phone,
      },
    };

    createmutation.mutate(payload, {
      onSuccess: () => {
        toast.success("Patient created");
        closeModal();
      },
      onError: () => {
        toast.error("Something went wrong");
      },
    });
  };

  return (
    <CuModal>
      <CuForm onSubmit={handleSubmit}>
        <div className="flex justify-between">
          <h3 className="font-normal">Add Patient</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 cursor-pointer"
            onClick={closeModal}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </div>
        {type === "institution" && (
          <div>
            <label>Select Customer</label>
            <CuDropdown
              placeholder="Select customer"
              options={institutionOptions}
              onChange={(val) => handleChange(val, "institution")}
              required={true}
              searchable
              onSearch={(val) => setSearchInput(val)}
            />
          </div>
        )}
        <div>
          <CuInput
            label={"Phone"}
            required={true}
            type={"number"}
            value={formData?.phone}
            onChange={(e) => handleChange(e.target.value, "phone")}
          />
        </div>
        <div>
          <CuInput
            label={"Full Name"}
            required={true}
            value={formData?.full_name}
            onChange={(e) => handleChange(e.target.value, "full_name")}
          />
        </div>
        <div>
          <DateAge
            value={{
              age: formData.age,
              dob: formData.dob,
            }}
            onChange={(val) => handleChange(val, "dateAge")}
            id="date-age-custom"
            placeholder="age"
          />
        </div>
        <div>
          <label>Gender</label>
          <div className="bookslot-gender">
            {gender.map((gen) => (
              <div key={gen.id} className="bookslot-genderbtns mb-2">
                <input
                  type="radio"
                  required={true}
                  checked={formData?.gender === gen.label}
                  onChange={(e) => handleChange(gen.label, "gender")}
                />
                <label>{gen.label}</label>
              </div>
            ))}
          </div>
        </div>
        <div className="btn-center">
          <CustomButton
            color={"rgba(199, 234, 201, 1)"}
            textColor={"rgba(0, 0, 0, 1)"}
            className="btn-mobile"
            style={{ width: "100%", height: "40px" }}
            type="submit"
            loading={createmutation.isLoading}
          >
            Add Patient
          </CustomButton>
        </div>
      </CuForm>
    </CuModal>
  );
};

export default AddUserModal;
